import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import {
  ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE, DEFINED_TYPE_LINKS,
  DISPLAY_BUTTON,
  GENDER,
  PROFILE,
  SEARCH_TYPE,
  SEARCH_USER_FILTER,
} from '../../config/constants';
import styles from './styles.module.scss';
import { useQuery, useQueryClient } from 'react-query';
import * as searchApi from 'api/search';
import FormDialog from 'components/SearchFormDialog';
import { MuiThemeProvider } from '@material-ui/core';
import { Col, Row } from 'antd';
import { getAllTags } from '../../api/tag';
import { getTextWebPages } from '../../api/textWebPage';
import { fixedHeaderSticky, getLocalStorage, removeLocalStorage, setLocalStorage } from '../../utils/utils';
import { AuthContext } from '../../context/AuthContext';
import { AppContext } from '../../context/AppContext';
import { customThemeTableSearch } from '../../themeMui/customer-table-search';


const styleWrapInline = {
  display: 'inline-block',
};

const styleWrap = {
  fontSize: '95%',
  fontColor: 'var(--emperor)',
  fontFamily: '"Times New Roman", Times, serif, ヒラギノ角ゴ ProN',
};

function Search(props) {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const queryClient = useQueryClient();
  const [photoStatus, setPhotoStatus] = useState('');
  const [ageFrom, setAgeFrom] = useState('');
  const [ageTo, setAgeTo] = useState('');
  const [provinces, setProvinces] = useState([]);
  const [standByStatus, setStandByStatus] = useState('');
  const [valueTags, setValueTags] = useState([]);
  const [valueObj, setValueObj] = useState({});
  const [values, setValues] = useState({});
  const [resourceTags, setResourceTags] = useState([]);


  const profileMeta = authContext.profileMeta
  const userProfile = authContext.userProfile
  const listState = appContext.listState;
  const envUi = authContext.envUi
  const resultAllTags = useQuery('getAllTags', getAllTags, { cacheTime: Infinity });
  const stickyContent = props?.textWebPage || '';

  useEffect(() => {
    const fetchLocalStorage = async () => {
      const dataRaw = await getLocalStorage(SEARCH_USER_FILTER);
      if (dataRaw) {
        try {
          const data = JSON.parse(dataRaw);
          if (data?.options) {
            setValueObj(data?.options);

            if (data?.options?.tags) {
              setValueTags(data?.options?.tags);
            }
            if (data?.options?.states) {
              setProvinces(data?.options?.states);
            }
          }
          if (data?.avatar) {
            setPhotoStatus(data?.avatar);
          }
          if (data?.age_from) {
            setAgeFrom(data?.age_from);
          }
          if (data?.age_to) {
            setAgeTo(data?.age_to);
          }
          if (data?.profiles) {
            setValues(data?.profiles);
          }
          if (data?.standBy) {
            setStandByStatus(data?.standBy);
          }
        } catch (e) {
          // Todo
        }
      }
    };

    fetchLocalStorage();
  }, []);

  useEffect(() => {
    if (resultAllTags?.data) {
      setResourceTags((resultAllTags?.data?.data ?? []));
    }
  }, [resultAllTags]);

  // Sticky sticky content
  useEffect(() => {
    const sectionScroll = document.querySelector('#section-scroll-content');
    if (!sectionScroll) {
      return;
    }
    sectionScroll.addEventListener('scroll',
      e => fixedHeaderSticky(sectionScroll, stickyContent, { e, paddingTop: false }),
      true);
    return () => {
      sectionScroll.removeEventListener('scroll',
        e => fixedHeaderSticky(sectionScroll, stickyContent, { e, paddingTop: false }),
        true);
    };
  }, [stickyContent, fixedHeaderSticky]);

  const handleClearSearch = async () => {
    setPhotoStatus(null);
    setAgeFrom(null);
    setAgeTo(null);
    setProvinces([]);
    setStandByStatus(null);
    setValues({});
    setValueObj({});
    setValueTags([])
    await removeLocalStorage(SEARCH_USER_FILTER);
  };

  let displayAgeList = () => {
    let list = [];
    for (let i = 18; i <= 100; i++) {
      list.push(i);
    }
    return list;
  };

  const handleSearch = async () => {
    const data = {
      avatar: !photoStatus ? null : photoStatus,
      age_from: ageFrom ? ageFrom : '',
      age_to: ageTo ? ageTo : '',
      profiles: { ...values },
      states: !provinces ? null : provinces,
      standBy: standByStatus,
      ...valueObj && { options: valueObj },
    };
    await setLocalStorage(SEARCH_USER_FILTER, JSON.stringify(data));
    try {
      const { data: userSearchList, message } = await searchApi.searchUser(data);

      // Set data to query data after fetch api
      queryClient.setQueryData('userSearchList', userSearchList);
      queryClient.setQueryData('userSearchListMessage', message);

      history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/search-result` });
    } catch (e) {
      console.error(e.response?.data?.message);
    }
  };

  const renderSearchBox = () => {
    const userGender = userProfile.gender === GENDER.FEMALE ? 'male' : 'female';
    // List Group Resource Profile
    const profileParent = {};

    const resourceChildren = profileMeta.reduce((accumulator, currentItem) => {
      if (currentItem.gender === userGender) {
        const keyProfile = currentItem['profile'];
        // handle Profile Parent
        if (currentItem.value === PROFILE.ROOT) {
          // check Profile Parent is exist in List Group Resource Profile
          if (!profileParent[keyProfile]) {
            profileParent[keyProfile] = {};
          }
          // Title of Resource Item
          profileParent[keyProfile]['title'] = currentItem.label;
          // Profile Order to specify the order displayed on the Profile Screen
          profileParent[keyProfile]['searchOrder'] = currentItem.searchOrder;
          profileParent[keyProfile]['searchType'] = currentItem.searchType;
        }
        // Handle Profile Children
        if (currentItem.value !== PROFILE.ROOT) {
          // Group By Profile Parent
          if (!accumulator[keyProfile]) {
            accumulator[keyProfile] = [];
          }
          accumulator[keyProfile].push(currentItem);
        }
      }
      return accumulator;
    }, []);

    //Display List Profile Group and sorting by profileOrder that is used in Profile screen
    return Object.keys(profileParent)
      .sort((a, b) => profileParent[a].searchOrder - profileParent[b].searchOrder)
      .map((profile, key, row) => {
        const isLastElement = key + 1 === row.length;

        // 1
        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.DROPDOWN) {
          return (
            <Row key={key}>
              <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                 <span style={styleWrap} className="font-2">
                   {profileParent[profile]?.title}
                 </span>
              </Col>
              <Col xs={12} style={{ padding: '1px 0 4px' }}>
                <div className="d-item-box-search-text">
                  <FormDialog
                    namevalue={values[profile] || []}
                    namelabel={profileParent[profile]?.title}
                    resource={resourceChildren[profile]}
                    user={userProfile}
                    onchangeData={(e) => onchangeData(e, profile)}
                    type={'single'}
                    text={showProfile(resourceChildren[profile], values[profile])}
                  />
                </div>
              </Col>
            </Row>
          );
        }
        // 2
        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.CHECKBOX) {
          return (
            <Row key={key} style={{ marginBottom: isLastElement ? '68px' : '' }}>
              <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                <span style={styleWrap} className="font-2">
                  {profileParent[profile]?.title}
                </span>
              </Col>
              <Col xs={12} style={{ padding: '1px 0 4px' }}>
                <div className="d-item-box-search-text">
                  <FormDialog
                    namevalue={values[profile] || []}
                    namelabel={profileParent[profile]?.title}
                    resource={resourceChildren[profile]}
                    user={userProfile}
                    onchangeData={(e) => onchangeData(e, profile)}
                    type={'multiple'}
                    text={showProfile(resourceChildren[profile], values[profile])}
                  />
                </div>
              </Col>
            </Row>
          );
        }
        // 3
        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.RANGE) {
          return (
            <div key={key}>
              <ListItem className={`${styles.lableSelect} font-2`} style={{ padding: '4px 0 0 0' }}>
                {profileParent[profile]?.title}
              </ListItem>
              <ListItem style={{ padding: "0 0 4px 0" }}>
                <div className="d-item-box-search d-flex justify-content-center">
                  <div className="d-range-left" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={values[profile + '_from']}
                      namelabel={profileParent[profile]?.title}
                      resource={resourceChildren[profile]}
                      user={userProfile}
                      onchangeData={(e) => onchangeData(e, `${profile}_from`)}
                      text={showProfile(resourceChildren[profile], values[profile + '_from'])}
                    />
                  </div>
                  <div className="d-symbol-range">~</div>
                  <div className="d-range-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={values[profile + '_to']}
                      namelabel={profileParent[profile]?.title}
                      resource={resourceChildren[profile]}
                      user={userProfile}
                      onchangeData={(e) => onchangeData(e, `${profile}_to`)}
                      text={showProfile(resourceChildren[profile], values[profile + '_to'])}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
          );
        }

        return null;
      });
  };

  const onchangeData = (data, name) => {
    if (name === 'tags' || name === 'states') {
      setValueObj({ ...valueObj, [name]: data });
      if (name === 'tags') {
        setValueTags(data);
      }
      if (name === 'states') {
        setProvinces(data);
      }
      return;
    }
    if (name === 'photo') {
      setPhotoStatus(data);
    }
    if (name === 'agefrom') {
      setAgeFrom(data);
    }
    if (name === 'ageto') {
      setAgeTo(data);
    }
    if (name === 'standBy') {
      setStandByStatus(!standByStatus ? 1 : null);
    }

    setValues({ ...values, [name]: data });
  };

  // const showValuePhoto = () => {
  //   if (photoStatus) {
  //     return searchPhoto.find((item) => item.value === photoStatus)?.label;
  //   }
  //   return null;
  // };

  const showValueTags = () => {
    let dataTags = valueObj?.tags ?? [];

    return resourceTags.filter((item) => dataTags.includes(item.id))
      .map(ele => `<span class="d-symbol-search">${ele.label}</span>`)
      .join('');
  };

  const showValueAgeFrom = () => {
    if (ageFrom) {
      return displayAgeList().find((item) => item === ageFrom);
    }
    return null;
  };

  const showValueAgeTo = () => {
    if (ageTo) {
      return displayAgeList().find((item) => item === ageTo);
    }
    return null;
  };

  const showValueStates = () => {
    const dataTags = valueObj?.states ?? [];

    return listState?.filter(item => dataTags.includes(item.id))
      .map(ele => `<span class="d-symbol-search">${ele.label}</span>`)
      .join('');
  };

  const showProfile = (list, data) => {
    if (data) {
      if (Array.isArray(data)) {
        let result = '';
        data.map((item) => {
          list.forEach(it => {
            if (it.value === item) {
              result += `<span class="d-symbol-search">${it.label}</span>`;
            }
          });
        });

        return result;
      } else {
        return list.find((item) => item.value === data)?.label;
      }
    }
    // return null;
  };

  return (
    <React.Fragment>
      <MuiThemeProvider theme={customThemeTableSearch}>
        <div id={'section-scroll-content'}
             className={`${styles.searchScreen} d-search-user-wrapper`}
             style={{ overflowY: 'auto', height: '100vh' }}>
          <div>
            <div>
              <div className={styles.topNavContainer}>
                <TopNav name={'ユーザー検索'} hasLogo={true} hasHamburger={true} />
              </div>

              {stickyContent && (
                <div id={'header-section'}
                     className="d-wrapper-header-section d-wrapper-header-padding box-sticky-content"
                     >
                  <div className={'sticky-content d-info-text font-3'}
                       dangerouslySetInnerHTML={{ __html: stickyContent }}></div>
                </div>
              )}

              <div id={'wrapper-box-msg'}
                   className={`${styles.listSelect} d-search-box d-wrapper-box-msg ${!!(stickyContent && stickyContent.length) ? 'd-sticky-content-has' : 'd-sticky-content-none'}`}>
                {/*<div>*/}
                <Row>
                  {envUi?.searchCallStandby === DISPLAY_BUTTON.SHOW && <React.Fragment>
                    <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                      <span style={styleWrap} className="font-2">
                        会話待機
                      </span>
                    </Col>
                    <Col xs={12} style={{ display: 'flex', justifyContent: 'center', padding: '1px 0 4px' }}>
                      <div
                        className={`${styles.btnItemSearch} d-item-box-search ${standByStatus ? 'bg-main-search' : 'bg-main-search-none'}`}
                        onClick={() => onchangeData(1, 'standBy')}>
                        <div className="">{standByStatus ? '待機中のみ表示' : '全て'}</div>
                      </div>
                    </Col>
                  </React.Fragment>
                  }
                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                    <span style={styleWrap} className="font-2">
                      写真
                    </span>
                  </Col>
                  <Col xs={12} className="d-flex justify-content-center d-item-box-search-text">
                    <div
                      className={`${styles.btnItemSearch} w-100 mr-10 ${!photoStatus ? 'bg-main-search' : 'bg-main-search-none'}`}
                      onClick={() => onchangeData(null, 'photo')}>
                      <div className="">全て</div>
                    </div>
                    <div
                      className={`${styles.btnItemSearch} w-100 mr-10 ${photoStatus === 1 ? 'bg-main-search' : 'bg-main-search-none'}`}
                      onClick={() => onchangeData(1, 'photo')}>
                      <div className="">写真なし</div>
                    </div>
                    <div
                      className={`${styles.btnItemSearch} w-100 ${photoStatus === 2 ? 'bg-main-search' : 'bg-main-search-none'}`}
                      onClick={() => onchangeData(2, 'photo')}>
                      <div className="">写真あり</div>
                    </div>
                  </Col>
                  {envUi?.searchTag === DISPLAY_BUTTON.SHOW &&
                  (
                    <React.Fragment>
                      <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                      <span style={styleWrap} className="font-2">
                        Myタグ
                      </span>
                      </Col>
                      <Col xs={12} className="d-flex justify-content-center">
                        <div className="d-item-box-search">
                          <FormDialog
                            valueName={valueTags}
                            nameValues={valueTags}
                            namelabel={'Myタグ'}
                            nametext="tags"
                            resource={resourceTags}
                            user={userProfile}
                            onchangeDatas={(e) => onchangeData(e, 'tags')}
                            text={showValueTags()}
                            type={'multiple'}
                          />
                        </div>
                      </Col>
                    </React.Fragment>
                  )}
                  <div>
                    <ListItem className={`${styles.lableSelect} font-2`} style={{ padding: '4px 0 0 0' }}>年齢</ListItem>
                    <ListItem style={{ padding: "0 0 4px 0" }}>
                      <div className="d-item-box-search d-flex justify-content-center">
                        <div className="d-range-left" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                          <FormDialog
                            namevalue={ageFrom}
                            namelabel={'年齢'}
                            nametext="agefrom"
                            resource={displayAgeList()}
                            user={userProfile}
                            onchangeData={(e) => onchangeData(e, 'agefrom')}
                            text={showValueAgeFrom()}
                          />
                        </div>
                        <div className="d-symbol-range">~</div>
                        <div className="d-range-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                          <FormDialog
                            namevalue={ageTo}
                            namelabel={'年齢'}
                            nametext="ageto"
                            resource={displayAgeList()}
                            user={userProfile}
                            onchangeData={(e) => onchangeData(e, 'ageto')}
                            text={showValueAgeTo()}
                          />
                        </div>
                      </div>
                    </ListItem>
                  </div>

                  <Col xs={12} style={{ padding: '3px 0 0 0' }}>
                    <span style={styleWrap} className="font-2">
                      都道府県
                    </span>
                  </Col>
                  <Col xs={12} className="d-flex justify-content-center">
                    <div className="d-item-box-search">
                      <FormDialog
                        valueName={provinces}
                        nameValues={provinces}
                        namelabel={'都道府県'}
                        nametext="states"
                        resource={listState}
                        user={userProfile}
                        onchangeDatas={(e) => onchangeData(e, 'states')}
                        text={showValueStates()}
                        type={'multiple'}
                      />
                    </div>
                  </Col>
                </Row>
                {renderSearchBox()}

                <List>
                  <ListItem alignItems="flex-start" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        position: 'fixed',
                        bottom: 56,
                        margin: 'auto',
                        width: '100%',
                        padding: '8px 0',
                        maxWidth: '544px',
               
                      }}
                    >
                      <Button className="btn btn-main" variant="contained" onClick={handleSearch}>
                        <span>検索する</span>
                      </Button>
                      <Button className="btn btn-sub" variant="contained" onClick={handleClearSearch}>
                        <span>クリア</span>
                      </Button>
                    </div>
                  </ListItem>
                </List>
              </div>
              <BottomNav />
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    </React.Fragment>
  );
}

Search.getInitialProps = async ({
                            req, res, match, history, location, ...ctx
                          }) => {
  let textWebPages = [];
  try {
    let result = await getTextWebPages();
    textWebPages = result?.data || [];
  } catch (e) {
    textWebPages = [];
  }

  const findBlogMyEdit = textWebPages?.data?.find(ele => ele.link === DEFINED_TYPE_LINKS.SEARCH_USER && ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE.includes(DEFINED_TYPE_LINKS.SEARCH_USER));

  return { textWebPage: findBlogMyEdit?.content || '' };
};

export default Search;
